import { HttpHandler, HttpHeaders, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DeviceService } from './device.service';

// @Injectable()
// export class DeviceInterceptor implements HttpInterceptor {

//   // this causes a circular dependency because the device detector service depends on the http client.
//   // solutions is to just set these properties once on app init.
//   // ue a device service that this interceptor depends on, and in the app boostrapping, also depend on that device service and set the properties
//   // constructor(private deviceService: DeviceService) {}

//   intercept(req: HttpRequest<any>, next: HttpHandler) {

//     let authReq;
//     if (req.headers.has('x-ignore-device-interceptor')) {
//       authReq = req.clone({
//         headers: new HttpHeaders()
//       });
//     } else {
//       // TODO: The device type is hard-coded to 3, but may need to be changed while on mobile. Can be derived from navigator.
//       authReq = req.clone({
//         headers: req.headers
//           .set('x-auth-deviceid', this.deviceService.getUserAgent() ?? 'none')
//           .set('x-auth-devicetype', this.deviceService.getDeviceType() ?? '2')
//       });
//     }

//     return next.handle(authReq);
//   }
// }

export const deviceInterceptor : HttpInterceptorFn = (req, next) =>{
  const deviceService = inject(DeviceService);
  let authReq;
  if (req.headers.has('x-ignore-device-interceptor')) {
    authReq = req.clone({
      headers: new HttpHeaders()
    });
  } else {
    // TODO: The device type is hard-coded to 3, but may need to be changed while on mobile. Can be derived from navigator.
    authReq = req.clone({
      headers: req.headers
        .set('x-auth-deviceid', deviceService.getUserAgent())
        .set('x-auth-devicetype', deviceService.getDeviceType())
        // .set('x-auth-deviceid', 'adsfasdfasdfs')
        // .set('x-auth-devicetype', '2')
    });
  }

  return next(authReq);
};
